import CryptoJS from 'crypto-js';

let secretKey;
let iv

export const setSecretKey = (key) => {
  secretKey = key;
  iv = secretKey.substring(0, 16);
};

export const encryptData = (data) => {
  if (!secretKey) {
    throw new Error('Secret key is not set.');
  }
  if (!data) {
    return null;
  }
  if (typeof data !== 'object') {
    throw new Error('Data must be an object.');
  }
  try {
    const jsonData = JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(jsonData,
        CryptoJS.enc.Utf8.parse(secretKey), {
          iv: CryptoJS.enc.Utf8.parse(iv),
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
    return encrypted.toString();
  } catch (error) {
    return null;
  }
};

export const decryptData = (cipherText) => {
  if (!secretKey) {
    throw new Error('Secret key is not set.');
  }
  if (!cipherText) {
    return null;
  }
  try {
    const decrypted = CryptoJS.AES.decrypt(cipherText,
        CryptoJS.enc.Utf8.parse(secretKey), {
          iv: CryptoJS.enc.Utf8.parse(iv),
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    return null;
  }
};
